<template>
  <div class="container-info">
    <div class="close">
      <span @click="close()">x</span>
    </div>
    <div class="info">
      <span>{{ message }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modal-info',
  data() {
    return {
      message: this.$store.getters.message,
    };
  },
  methods: {
    close() {
      this.$store.commit('CLOSE_MODAL', false);
    },
  },
};
</script>
<style lang="scss">
.close {
    position: fixed;
    right: 29vw;
    top: 35.5vh;
    cursor: pointer;
    span {
      font-size: 1.4rem;
      color: $header;
      @media (max-width: 960px) {
        font-size: 3rem;
      }
    }
    @media (max-width: 960px) {
      right: 8vw;
      top: 5vh;
    }
  }
.container-info {
  position: fixed;
  display: flex;
  align-items: center;
  z-index: 10;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(48, 48, 48, 0.5);
  .info {
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    background-color: $white;
    width: 44.2vw;
    height: 30.5vh;
    border-radius: 10px;
    @media (max-width: 960px) {
      width: 100%;
      height: 100%;
      border-radius: 0px;
    }
    span {
      font-weight: 500;
      font-size: 24px;
      letter-spacing: 0.274837px;
      color: $black;
    }
  }
}
</style>
